import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../util/axios";
import { notification } from "antd";
import { connectResourceProvider } from "../types/provider-resource";
import { ProviderResource } from "../components/ResourceTable/ResourceTable.types";
import { useTranslation } from "react-i18next";

export const useGetUnconnectedProviders = () =>
  useQuery<ProviderResource[]>({
    queryKey: ["providerResourceList"],
    queryFn: () =>
      axiosInstance
        .get("provider-resource/list/unconnected")
        .then((w) => w.data),
    initialData: [],
  });

export const useConnectProvider = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: connectResourceProvider) =>
      axiosInstance.post("/provider-resource/connect", data),
    onSuccess: () => {
      notification.success({
        message: t("toast.resource-connected-successfully"),
      });
      queryClient.invalidateQueries({ queryKey: ["resourcesList"] });
      return queryClient.invalidateQueries({
        queryKey: ["providerResourceList"],
      });
    },
    onError: () => {
      notification.error({
        message: t("toast.failed-to-connect-resource"),
      });
    },
  });
};

export const useDisconnectProvider = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      axiosInstance.post("/provider-resource/disconnect", {
        providerResourceId: id,
      }),
    onSuccess: () => {
      notification.success({
        message: t("toast.resource-disconnected-successfully"),
      });
      queryClient.invalidateQueries({ queryKey: ["resourcesList"] });
      return queryClient.invalidateQueries({
        queryKey: ["providerResourceList"],
      });
    },
    onError: () => {
      notification.error({
        message: t("toast.failed-to-disconnect-resource"),
      });
    },
  });
};
